import React, {useEffect, useState} from "react";
import "../../styles/css/Chart.css";
import micro_reporter_api from "../../apis/micro-reporter-api";
import LineChart from "../chart/LineChart";
import BarChart from "../chart/BarChart";
import PieChart from "../chart/PieChart";
import {COLOR_PALATTE} from "../../config/constants"
import Utils from "../../libraries/utils";

const DashboardChart = (props) => {

	const [selectedChart, setSelectedChart] = useState();

	const [data, setData] = useState();
	const [clickCreate, setClickCreate] = useState(false);
	const [teamPerformanceChart, setTeamPerformanceChart] = useState();
	const [chartTitle, setChartTitle] = useState('');
	const [displayValue, setDisplayValue] = useState();
	const [showErrorMessage, setShowErrorMessage] = useState(false);
	const [reportName,setReportName] = useState('');

	useEffect(() => {
		if (teamPerformanceChart) {
			teamPerformanceChart.destroy();
		}
    createChartButton(props.chartWidgets);
	}, []);


	const createChartButton = (e) => {
		
    let user = JSON.parse(localStorage.getItem("user"));
    let uniqueList = [];
    let value;
    if(e){
      if (e.reportChart.selectedSubjects && e.reportChart.selectedSubjects.length > 0) {
        e.reportChart.selectedSubjects.map(t => {
          uniqueList.push(t.label);
        })
      }
      value = {
        "reportId": e.reportChart.report.id,
        "chartType": e.reportChart.chartType,
        "subject": e.reportChart.subject,
        "selectedSubjects": uniqueList,
        "horizontalAxisColumn": e.reportChart.chartType === "Pie" ? null : e.reportChart.horizontalAxisColumn,
        "verticalAxisColumn": e.reportChart.chartType === "Pie" ? null : e.reportChart.verticalAxisColumn,
        "pieColumn": e.reportChart.chartType === "Pie" ? e.reportChart.pieColumn : null,
      }
      setChartTitle(e.reportChart.name);
      setSelectedChart(e.reportChart.chartType);
			setReportName(e.reportChart.report.name);
      try {
				Utils.loadingScreen("show");
        (async () => {
          let headers = { "userId": user.id, "username": user.username, "relatedName": encodeURIComponent(e.reportChart.name), "relatedId": value.reportId };
          const config = { headers };
          await micro_reporter_api.post('/micro-reporter/chart-detail/chart-data', value, config).then(
            (response) => {
              response.data.datasets = response.data.datasets.map((item) => {
                let index = value.selectedSubjects.indexOf(item.label);
                let color = generateColor(value.selectedSubjects.length, index,  value.chartType);
                return { borderColor: color, backgroundColor: color, radius: 4, borderWidth: 2, fill: false, ...item };
              });
              setData(response.data);
              setClickCreate(true);
							Utils.loadingScreen("hide");
            }
          );
        })();
      } catch (e) {
				Utils.loadingScreen("hide");
        setShowErrorMessage(true);
      }
    }
    
	
	};

	const generateColor = (size, item, chart) => {
		if (chart === 'Line' || chart === 'Bar') {
			let color = COLOR_PALATTE[item];
			return color;
		} else {
			var colorList = [];
			for (var j = 0; j < size; j++) {
				let color = COLOR_PALATTE[j];
				colorList.push(color);
			}
			return colorList;
		}
	};

	const showChart = () => {
		
		if (selectedChart === 'Bar') {
			return (
				<div>
					<BarChart data={data}
						setTeamPerformanceChart={setTeamPerformanceChart}
						teamPerformanceChart={teamPerformanceChart} 
						id={props.chartWidgets.reportChart.name + "_" + props.chartWidgets.reportChart.id}/>
				</div>
			);
		} else if (selectedChart === 'Pie') {
			return (
				<div>
					<PieChart data={data}
						fontSize={15}
            pie={''}
						setTeamPerformanceChart={setTeamPerformanceChart}
						teamPerformanceChart={teamPerformanceChart}
						id={props.chartWidgets.reportChart.name + "_" + props.chartWidgets.reportChart.id} />
				</div>
			)
		} else if (selectedChart === 'Line') {
			return (
				<div>
					<LineChart data={data}
            line={''}
						setTeamPerformanceChart={setTeamPerformanceChart}
						teamPerformanceChart={teamPerformanceChart}
						id={props.chartWidgets.reportChart.name + "_" + props.chartWidgets.reportChart.id} />
				</div>
			)
		}
	};

	const linkToChart = () => {
		window.location.href = "/chart?reportId=" + props.chartWidgets.reportChart.report.id;
	}

	return (
		<div>
			<div id="">
				<div className="report-title" onClick={() => linkToChart()}>{reportName}</div>
				<div className="chart-title">{chartTitle}</div>
				<div className="dashboard-chart-wrapper">
					{clickCreate ? showChart() : ''}
				</div>
			</div>
		</div>
	);
}

export default DashboardChart;
